export const SHARES_LIST = 'sharesList';
export const IS_SHARES_LOADING = 'isSharesLoading';
export const PHYSICIAN_ADMIN_LIST = 'physicianAdmins';
export const PHYSICIAN_LIST = 'physicians';
